import { observer } from 'mobx-react-lite';
import { DataGrid, NoItemsBox } from '../../../../components';
import PulseKeys from '../../store/PulseKeys';
import PulseKeySearch from '../../store/PulseKeySearch';
import createColumns from './createColumns';
import KeysGridToolbar from './KeysGridToolbar';

export default observer(function KeysGrid({
  pulseKeys,
  search,
}: {
  pulseKeys: PulseKeys;
  search: PulseKeySearch;
}) {
  return (
    <>
      <KeysGridToolbar pulseKeys={pulseKeys} search={search} />
      <DataGrid
        columns={createColumns(search)}
        data={pulseKeys.items}
        idField="key"
        onOrderByChange={search.setOrderBy}
        orderBy={search.orderBy}
      />
      {pulseKeys.items.length === 0 && (
        <NoItemsBox>No PulseKeys found</NoItemsBox>
      )}
    </>
  );
});
